<script>
  export default {
  	data: function () {
		   return {
		     childData: ''
		   }
		},
	props: {
      dialog: {
        	default: false,
      },
      commentId:{
      	type: String
      },
      modalTitle:{
      	type: String
      }, 
      parentData: {
	     type: String,
		     default () {
		       return ''
	     }
  	  }
    },
    methods: {
    	showing1(){
		 	this.$nextTick(this.$refs.approve_remark.$el.focus)
    	},
      	close() {
       	 	this.$emit('close');
     	 },
     	 // maybe onchagne may onclick whatever..
		   handleDataFc: function () {
		   	console.log("adsadasd"+this.childData)
		     this.$emit('interface', this.childData) // handle data and give it back to parent by interface
		     //debugger
		   }
    },
		beforeMount () {
		   this.childData = this.commentId // save props data to itself's data and deal with it
		   
		}
  }
</script>
<template>
  
  	 <v-card>
      <v-card-title>
        <span class="headline"> {{modalTitle}} {{commentId}}</span>
          <v-spacer></v-spacer>
	       <v-btn icon @click="close">
	        <v-icon>close</v-icon>
	      </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6>
              <v-textarea
			      name="input-7-1"
			      box
			      label="Remarks (optional)"
			      auto-grow
			      value=""
			    background-color="white" ref="approve_remark"></v-textarea>
            </v-flex>
           
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" 
          @click="handleDataFc" ref="cancelTestDialog1">Close</v-btn>
        <v-btn color="blue darken-1">Save</v-btn>
      </v-card-actions>
     </v-card>
    
</template>